import React from "react";
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, Button, Flex, Text, VStack, Center, useToast, FormControl, FormErrorMessage, } from "@reverb-ui/react";
import { format } from "date-fns";
import { convertCentsToUnit } from "@/shared/utils";
import { useContext } from "react";
import { TransactionsContext } from "@/shared/presentation/context-api/providers/transaction";
import { useState } from "react";
export var ModalRefundPurchase = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, transaction = _a.transaction;
    var chargebackTransaction = useContext(TransactionsContext).chargebackTransaction;
    var toast = useToast();
    var _b = useState(), error = _b[0], setError = _b[1];
    var makeChargeback = function (transaction) {
        chargebackTransaction(transaction)
            .then(function () {
            toast({
                title: "Successfully refunded",
                description: "We've refunded your transaction",
                status: "success",
                duration: 9000,
                isClosable: true,
            });
            onClose();
        })
            .catch(function (e) { return setError(e); });
    };
    if (!transaction || !isOpen)
        return React.createElement(React.Fragment, null);
    return (React.createElement(Modal, { isOpen: isOpen, onClose: onClose },
        React.createElement(ModalOverlay, null),
        React.createElement(ModalContent, null,
            React.createElement(ModalHeader, null, "Refund credits"),
            React.createElement(ModalCloseButton, null),
            React.createElement(ModalBody, null,
                React.createElement(Center, null,
                    React.createElement(Flex, { fontSize: "xl", alignItems: "center", fontWeight: "bold" },
                        React.createElement(Text, { pr: "1" }, "RC"),
                        React.createElement(Text, { fontSize: "4xl" }, convertCentsToUnit(transaction.value)))),
                React.createElement(VStack, { alignItems: "space-between", pt: "4", gridGap: "4" },
                    React.createElement(Flex, { justifyContent: "space-between" },
                        React.createElement(VStack, { alignItems: "flex-start" },
                            React.createElement(Text, { color: "gray.600", fontSize: "sm" }, "Date of purchase"),
                            React.createElement(Text, null, format(new Date(transaction.createdAt), "dd/MM/yyyy"))),
                        React.createElement(VStack, { alignItems: "flex-start" },
                            React.createElement(Text, { color: "gray.600", fontSize: "sm" }, "Type"),
                            React.createElement(Text, null, "Credits purchase"))),
                    React.createElement(VStack, { alignItems: "flex-start" },
                        React.createElement(Text, { color: "gray.600", fontSize: "sm" }, "Description"),
                        React.createElement(Text, null, transaction.description))),
                React.createElement(FormControl, { isInvalid: !!error },
                    React.createElement(FormErrorMessage, null, error === null || error === void 0 ? void 0 : error.message))),
            React.createElement(ModalFooter, null,
                React.createElement(Button, { variant: "outline", mr: 3, onClick: onClose }, "Cancel"),
                React.createElement(Button, { colorScheme: "blue", onClick: function () { return makeChargeback(transaction); } }, "Confirm")))));
};
